/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Rights_Item_WithdrawInputs */

const en_privacy_rights_item_withdraw = /** @type {(inputs: Privacy_Rights_Item_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right to withdraw consent`)
};

const de_privacy_rights_item_withdraw = /** @type {(inputs: Privacy_Rights_Item_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recht auf Widerruf der Einwilligung`)
};

const fr_privacy_rights_item_withdraw = /** @type {(inputs: Privacy_Rights_Item_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Droit de retrait du consentement`)
};

const es_privacy_rights_item_withdraw = /** @type {(inputs: Privacy_Rights_Item_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derecho a retirar el consentimiento`)
};

const it_privacy_rights_item_withdraw = /** @type {(inputs: Privacy_Rights_Item_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diritto di revoca del consenso`)
};

const nl_privacy_rights_item_withdraw = /** @type {(inputs: Privacy_Rights_Item_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recht om toestemming in te trekken`)
};

const pl_privacy_rights_item_withdraw = /** @type {(inputs: Privacy_Rights_Item_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prawo do cofnięcia zgody`)
};

const fi_privacy_rights_item_withdraw = /** @type {(inputs: Privacy_Rights_Item_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oikeus peruuttaa suostumus`)
};

const da_privacy_rights_item_withdraw = /** @type {(inputs: Privacy_Rights_Item_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ret til at trække samtykke tilbage`)
};

const sv_privacy_rights_item_withdraw = /** @type {(inputs: Privacy_Rights_Item_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rätt att återkalla samtycke`)
};

/**
* | output |
* | --- |
* | "Right to withdraw consent" |
*
* @param {Privacy_Rights_Item_WithdrawInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_rights_item_withdraw = /** @type {((inputs?: Privacy_Rights_Item_WithdrawInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Rights_Item_WithdrawInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_rights_item_withdraw(inputs)
	if (locale === "fr") return fr_privacy_rights_item_withdraw(inputs)
	if (locale === "es") return es_privacy_rights_item_withdraw(inputs)
	if (locale === "it") return it_privacy_rights_item_withdraw(inputs)
	if (locale === "nl") return nl_privacy_rights_item_withdraw(inputs)
	if (locale === "pl") return pl_privacy_rights_item_withdraw(inputs)
	if (locale === "fi") return fi_privacy_rights_item_withdraw(inputs)
	if (locale === "da") return da_privacy_rights_item_withdraw(inputs)
	if (locale === "sv") return sv_privacy_rights_item_withdraw(inputs)
	return en_privacy_rights_item_withdraw(inputs)
});